module.exports = __webpack_public_path__ + "img/Guam.1f2ebf03.png";